<template>
  <section
    class="al-overlay"
    :class="[{ 'is-active': isOverlayOpen }]"
    test-id="al-side-panel"
    @click.self="onClickOverlay"
  >
    <article class="al-side-panel" :class="[{ 'is-open-from-right': isOpenFromRight }]">
      <div class="al-secondary-side-panel">
        <span @click="onClickBackButton">
          <al-link :has-icon="isOpenFromRight ? 'arrow-right-inverted' : 'arrow-left-inverted'" />
        </span>
      </div>
      <div class="al-primary-side-panel">
        <!--
          @slot Main container to shown information inside side panel
        -->
        <slot />
      </div>
    </article>
  </section>
</template>

<script>
import AlLink from '../basics/AlLink.vue';

/**
 * Side panel with almendra design alignments, this component have an overlay which uses the
 * full screen and show the panel for the right or left side.
 * @displayName al-side-panel
 */
export default {
  name: 'AlSidePanel',
  components: {
    AlLink
  },
  props: {
    /**
     * Boolean flag to open panel or close.
     * @values true,false
     */
    isOverlayOpen: {
      type: Boolean,
      default: false
    },
    /**
     * Boolean flag to define whether panel opens for right side or left side.
     * @values true, false
     */
    isOpenFromRight: {
      type: Boolean,
      default: false
    }
  },
  // -------------------------------------------------
  // + Life Cicle
  // -------------------------------------------------
  methods: {
    onClickBackButton() {
      this.$emit('activete-back-button');
    },
    onClickOverlay() {
      this.$emit('activete-overlay');
    }
  }
};
</script>

<style lang="scss">
.al-overlay {
  background-color: rgb(54, 64, 63);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;

  transition: transition(basic);
  visibility: hidden;
  width: 100%;
  z-index: 3;

  .al-side-panel {
    background-color: color(white, lighten, 1);
    box-shadow: 32px 0 32px -12px rgba(54, 64, 63, 0.25);
    display: flex;
    height: 100%;
    left: -580px;
    max-width: 580px;
    padding-top: spacing(9);
    position: relative;
    transition: transition(basic);

    .al-secondary-side-panel {
      padding-left: spacing(8);
      padding-right: spacing(6);

      .icon {
        color: color(black, lighten, 1);
        cursor: pointer;
        line-height: spacing(7);
      }
    }

    .al-primary-side-panel {
      line-height: line-height(s);
      padding-right: spacing(11) + spacing(1);
      width: 100%;

      .al-side-panel-title {
        margin-top: 0;
      }
    }

    // Modifiers
    &.is-open-from-right {
      display: flex;
      justify-content: flex-end;
      left: initial;
      right: calc(-100%);

      .al-primary-side-panel {
        order: 1;
        padding-left: 60px;
        padding-right: 0;
        width: calc(100% - 80px);
      }

      .al-secondary-side-panel {
        order: 2;
      }
    }
  }

  &.is-active {
    background-color: rgba(54, 64, 63, 0.9);
    opacity: 1;
    visibility: visible;

    .al-side-panel {
      left: 0;

      &.is-open-from-right {
        left: initial;
        max-width: 580px;
        min-width: 580px;
        right: calc(-100% + 580px);
      }
    }
  }
}
</style>
